import type { FC } from 'react';
import { Typography } from '@mui/material';

import { StyledHeaderSectionWrapper } from '../../MplDeutschlandTicketCard/variants/components';

interface IPricingProps {
	/** Total price paid, pre-formatted (e.g. "10,00 €"). */
	formattedPrice: string;
	vatNote?: string;
	isCancelled?: boolean;
	isDiscounted?: boolean;
}

/** Price header: total paid + VAT note. */
export const Pricing: FC<IPricingProps> = ({
	formattedPrice,
	vatNote,
	isCancelled,
	isDiscounted,
}) => (
	<StyledHeaderSectionWrapper>
		<Typography
			variant="b1-m"
			color="primary.main"
			data-testid="ticketshop-ticket-price"
			sx={isCancelled ? { textDecoration: 'line-through' } : undefined}
		>
			{formattedPrice}
			{isDiscounted && '*'}
		</Typography>
		{vatNote && (
			<Typography variant="l1" color="solutions.600">
				{vatNote}
			</Typography>
		)}
	</StyledHeaderSectionWrapper>
);
